import { httpClient } from '@/Common/api/http_client';


/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getMerchantCountries() {
  return httpClient.get('/countries');
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getMerchantStates(countryId) {
  return httpClient.get(`/countries/${countryId}/states`);
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getMerchantCities(stateId) {
  return httpClient.get(`/states/${stateId}`);
}
